import {
  FETCH_BANK_DETAILS_REQUEST,
  FETCH_BANK_DETAILS_SUCCESS,
  FETCH_BANK_DETAILS_FAILURE,
  CREATE_BANK_DETAILS_REQUEST,
  CREATE_BANK_DETAILS_SUCCESS,
  CREATE_BANK_DETAILS_FAILURE,
  DELETE_BANK_DETAILS_REQUEST,
  DELETE_BANK_DETAILS_SUCCESS,
  DELETE_BANK_DETAILS_FAILURE,
  UPDATE_BANK_DETAILS_REQUEST,
  UPDATE_BANK_DETAILS_SUCCESS,
  UPDATE_BANK_DETAILS_FAILURE,
} from "../actions/types";

const initialState = {
  bankDetails: [],
  loading: false,
  error: null,
  message: "",
};

const bankDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Requests
    case FETCH_BANK_DETAILS_REQUEST:
    case CREATE_BANK_DETAILS_REQUEST:
    case DELETE_BANK_DETAILS_REQUEST:
    case UPDATE_BANK_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };

    // Fetch success
    case FETCH_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        bankDetails: action.payload,
        message: "Bank details loaded successfully",
      };

    // Create success
    case CREATE_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        bankDetails: [...state.bankDetails, action.payload],
        message: "Bank details created successfully",
      };

    // Update success
    case UPDATE_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        bankDetails: state.bankDetails.map((bank) =>
          bank.bank_id === action.payload.bank_id ? action.payload : bank
        ),
        message: "Bank details updated successfully",
      };

    // Delete success
    case DELETE_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        bankDetails: state.bankDetails.filter(
          (bank) => bank.bank_id !== action.payload
        ),
        message: "Bank details deleted successfully",
      };

    // Failures
    case FETCH_BANK_DETAILS_FAILURE:
    case CREATE_BANK_DETAILS_FAILURE:
    case DELETE_BANK_DETAILS_FAILURE:
    case UPDATE_BANK_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default bankDetailsReducer;
